/**
 * Date/time formatting utilities.
 */

const defaultLocale = Intl.DateTimeFormat().resolvedOptions().locale;

export function formatDateTime(date, locale = defaultLocale) {
    if (!date) return null;
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(date));
}

export function formatDate(date, locale = defaultLocale) {
    if (!date) return null;
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(date));
}

export function formatTime(date, locale = defaultLocale) {
    if (!date) return null;
    return new Intl.DateTimeFormat(locale, {
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(date));
}
